<template>
    <form @submit.prevent="register">
        <div class="row justify-content-center align-items-center ">
            <h3 class="text-uppercase pb-3">{{$ml.get('registration_form')}}</h3>
        </div>
        <div class="row justify-content-center align-items-center ">
            <div class="col-5">
                <div class="row">
                    <div class="col-6 form-group">
                        <label class="ml-2 text-uppercase mb-0" for="first_name">{{$ml.get('first_name')}}</label>
                        <input type="text" class="form-control" id="first_name" name="first_name" v-validate="'required'"
                               :placeholder="$ml.get('first_name')"
                               :class="{'is-invalid': errors.has('first_name')}" v-model="registrationData.first_name">
                        <small class="form-text text-danger pl-3"
                               v-if="errorMessages.first_name.length">
                            {{errorMessages.first_name}}
                        </small>
                    </div>
                    <div class="col-6 form-group">
                        <label class="ml-2 text-uppercase mb-0" for="last_name">{{$ml.get('last_name')}}</label>
                        <input type="text" class="form-control " id="last_name" name="last_name" v-validate="'required'"
                               :placeholder="$ml.get('last_name')"
                               :class="{'is-invalid': errors.has('last_name')}" v-model="registrationData.last_name">
                        <small class="form-text text-danger pl-3"
                               v-if="errorMessages.last_name.length">
                            {{errorMessages.last_name}}
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-5 form-group">
                <label class="ml-2 text-uppercase mb-0" for="email">{{$ml.get('email')}}</label>
                <input type="email" class="form-control " id="email" name="email" v-validate="'required|email'"
                       :placeholder="$ml.get('email')"
                       :class="{'is-invalid': errors.has('email')}" v-model="registrationData.email">
                <small class="form-text text-danger pl-3" v-if="errorMessages.email.length">
                    {{errorMessages.email}}
                </small>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-5 form-group">
                <label class="ml-2 text-uppercase mb-0" for="password">{{$ml.get('password')}}</label>
                <input type="password" class="form-control" id="password" name="password" v-validate="'required'"
                       :placeholder="$ml.get('password')"
                       :class="{'is-invalid': errors.has('password')}" v-model="registrationData.password">
                <small class="form-text text-danger pl-3"
                       v-if="errorMessages.password.length">
                    {{errorMessages.password}}
                </small>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-5 form-group">
                <label class="ml-2 text-uppercase mb-0" for="confirm_password">{{$ml.get('confirm_password')}}</label>
                <input type="password" class="form-control" id="confirm_password" name="confirm_password"
                       v-validate="'required'" :placeholder="$ml.get('confirm_password')"
                       :class="{'is-invalid': errors.has('confirm_password')}"
                       v-model="registrationData.confirm_password">
                <small class="form-text text-danger pl-3"
                       v-if="errorMessages.confirm_password.length">
                    {{errorMessages.confirm_password}}
                </small>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-5 pt-4 text-center">
                <font-awesome-icon icon="spinner" size="2x" class="fa-spin" v-if="loading"/>
                <button v-else type="submit" class="btn btn-lg btn-warning btn-block text-uppercase">
                    {{$ml.get('continue')}}
                </button>
            </div>
        </div>
        <div class="row justify-content-center align-items-center"
             v-if="errorMessages.generalError.length">
            <div class="col-5 form-group">
                <small class="form-text text-danger">
                    {{$ml.get('general_error_msg')}}
                </small>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: "Registration",
        data() {
            return {
                registrationData: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                    confirm_password: '',
                },
                errorMessages: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                    confirm_password: '',
                    generalError: ''
                },
                loading: false,
            }
        },
        methods: {
            register() {
                if (!this.loading) {
                    this.errorMessages = {
                        first_name: '',
                        last_name: '',
                        email: '',
                        password: '',
                        confirm_password: '',
                        generalError: ''
                    };
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.loading = true;

                            this.$store.dispatch('create', {plan: this.$store.state.plans[this.$store.state.selectedPlanIndex].id, ...this.registrationData}).then(response => {
                                this.loading = false;
                                this.$router.push({name: 'Billing'});
                            }).catch(error => {
                                if (error.status === 400) {
                                    error.data.forEach(obj => {
                                        this.errorMessages[obj.property_path] = obj.message;
                                    });
                                } else {
                                    this.errorMessages.generalError = 'error';
                                }
                                this.loading = false;
                            });
                        } else {

                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>